import Loader from 'Components/Loader';
import React, { FC } from 'react';

export interface LayoutWithPageLoadingProps {
    loading?: boolean;
    /**
     * Will not render the content until the array is asserted.
     */
    assertedItems?: any[];
}

const LayoutWithPageLoading: FC<LayoutWithPageLoadingProps> = ({ loading, children, assertedItems = [] }) => {
    return (
        <>
            {
                loading ?
                    <Loader /> :
                    (assertedItems.filter((x) => !x).length > 0 ? null : children)
            }
        </>
    )
}

export default LayoutWithPageLoading